// Storage is measured in original-file bytes; archived galleries are excluded by the API.
export const galleryStorageQuota = (subscription, files = []) => {
  const mb = subscription?.plan_details?.storage_mb;
  const used = subscription?.usage?.storage_used_bytes;
  if (mb == null || used == null || !Number.isFinite(Number(mb)) || !Number.isFinite(Number(used))) return null;
  const limit = Number(mb) < 0 ? null : Number(mb) * 1024 * 1024;
  const selected = files.reduce((total, file) => total + (Number(file.size) || 0), 0);
  const remaining = limit === null ? null : Math.max(0, limit - Number(used));
  return { limit, used: Number(used), selected, remaining,
    exceeded: limit !== null && (Number(used) >= limit || selected > remaining) };
};

export const formatStorage = (bytes) => {
  if (bytes === null) return 'Illimité';
  const unit = bytes >= 1024 ** 3 ? 'Go' : 'Mo';
  const value = bytes / (unit === 'Go' ? 1024 ** 3 : 1024 ** 2);
  return `${value.toFixed(2).replace('.', ',')} ${unit}`;
};
